import { ReduxAction } from '../../actions';
import {
  SET_SAML_IDP_COHORT_ID,
  FETCH_INSTITUTION_IDP_DATA_SUCCESS,
} from './actions';
import { SamlIdentityProviderPreLoginState } from './types';

export const INITIAL_STATE: SamlIdentityProviderPreLoginState = {
  cohortId: null,
  idpCandidates: [],
};

export const SamlIdentityProviderPreLogin = (
  state: SamlIdentityProviderPreLoginState = INITIAL_STATE,
  action: ReduxAction
): SamlIdentityProviderPreLoginState => {
  switch (action.type) {
    case SET_SAML_IDP_COHORT_ID: {
      const { cohortId } = action;
      return {
        ...state,
        cohortId,
      };
    }
    case FETCH_INSTITUTION_IDP_DATA_SUCCESS: {
      const { idps } = action;

      return {
        ...state,
        idpCandidates: idps,
      };
    }
    default: {
      return state;
    }
  }
};
